import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/db/db';
import { withSettingsDefaults } from '@/domain/settings/defaults';
import type { Settings } from '@/domain/types';

/**
 * The single settings row with defaults applied. `undefined` while the first
 * read is in flight; never undefined afterwards.
 */
export function useSettings(): Settings | undefined {
  return useLiveQuery(async () => withSettingsDefaults(await db.settings.get('settings')), []);
}
